import type * as PdfJs from 'pdfjs-dist'

let pdfJsPromise: Promise<typeof PdfJs> | null = null

/**
 * Loads PDF.js — and points it at its worker — the first time something needs to draw a PDF.
 * Both are dynamic imports, so the library is its own chunk and nothing is downloaded until a
 * preview opens. The load is shared and cached; a failed load (a flaky network) is forgotten, so
 * the next preview tries again instead of replaying the failure.
 */
export function loadPdfJs(): Promise<typeof PdfJs> {
  if (!pdfJsPromise) {
    const loading = (async () => {
      const [pdfJs, worker] = await Promise.all([
        import('pdfjs-dist'),
        import('pdfjs-dist/build/pdf.worker.min.mjs?url'),
      ])
      pdfJs.GlobalWorkerOptions.workerSrc = worker.default
      return pdfJs
    })()
    loading.catch(() => {
      pdfJsPromise = null
    })
    pdfJsPromise = loading
  }
  return pdfJsPromise
}
